import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { StringHelper } from "./string-helper";

/** The formcontrol must when having value ONLY consist of letters and numbers */
export function PasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let helper = new StringHelper();

    // do not count/validate for no input
    if (!control.value) {
      return null;
    }

    const passedValidation = helper.IsAcceptedPassword(control.value);
    return !passedValidation ? { IsNotAcceptedPassword: { value: control.value} } : null;
  };
}